import React from 'react'
import styles from './chatBotModal.module.scss'
import dynamic from 'next/dynamic'
import USBButton from '@usb-shield/react-button'
import {
    USBIconClose,
} from '@usb-shield/react-icons'
import { useSession } from 'next-auth/react';

interface RemoteChatPageComponentProps {
  sessionVal: {} | null
}

const RemoteChatPageComponent = dynamic<RemoteChatPageComponentProps>(
  async () => await import('remoteChat/RemoteChatPageComponent'),
  {
    ssr: false,
  }
)

interface ChatBotModalProps {
  isOpen: boolean
  onClose: () => void
}

/**
 * ChatBotModal component to display a modal popup.
 *
 * @param {ChatBotModalProps} props - The props for the modal.
 * @returns {JSX.Element | null} The rendered modal or null if not open.
 */
export const ChatBotModal: React.FC<ChatBotModalProps> = ({ isOpen, onClose }): JSX.Element | null => {
  const { data: session } = useSession();
  if (!isOpen) return null
  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <USBButton
            type="button"
            id="close-chat-modal"
            dataTestId="close-chat-modal"
            ariaLabel="Close chat modal"
            addClasses={styles.closeLoginModal}
            handleClick={onClose}
          >
            <USBIconClose USBIconClose="grey90"/>
          </USBButton>
        <div className={styles.chatContainer}>
          <RemoteChatPageComponent sessionVal={session}/>
        </div>
      </div>
    </div>
  )
}